import React from "react";
import { Button } from "@qgiv/core-donor";
import { Icon } from "@qgiv/core-react";

/**
 * @param {object} props
 * @param {string} props.cancelButtonLabel
 * @param {string} props.heading
 * @param {boolean} props.isCms
 * @param {Function} props.setDisplayModal
 * @returns {React.JSX.Element}
 */
const RecurringSummaryCancelContent = ({
    cancelButtonLabel,
    heading,
    isCms,
    setDisplayModal,
}) => (
    <div className="qg-vendor-recurring-summary-cancel recurring-summary-cancel -padding-top--15">
        <div className="-callout -padding--30">
            <div className="qg-vendor-recurring-summary-cancel-heading -padding-top--0 -text--center">
                <h2>{heading}</h2>
            </div>
            <div className="qg-vendor-recurring-summary-cancel-button -padding-top--20">
                <Button
                    type="submit"
                    disabled={isCms}
                    btnStyle="secondary"
                    classes="-color--theme-primary"
                    onClick={() => setDisplayModal((prevState) => !prevState)}
                >
                    <Icon
                        className="-margin-right--5"
                        glyph="ban-solid"
                        type="FontAwesome"
                    />
                    {cancelButtonLabel}
                </Button>
            </div>
        </div>
    </div>
);

export default RecurringSummaryCancelContent;
